import { render, staticRenderFns } from "./LsServiceList.vue?vue&type=template&id=46015b4f&scoped=true&"
import script from "./LsServiceList.vue?vue&type=script&lang=js&"
export * from "./LsServiceList.vue?vue&type=script&lang=js&"
import style0 from "./LsServiceList.vue?vue&type=style&index=0&id=46015b4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46015b4f",
  null
  
)

export default component.exports